import React, { useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import PropertyData from "./property-list.json";
// icon
import Icon from '@mdi/react';
import { mdiMapMarkerRadiusOutline, mdiBedOutline, mdiBathtubOutline, mdiLan, mdiCarSide, mdiCountertop, mdiDumbbell, mdiWifi, mdiShieldLockOutline } from '@mdi/js';
const iconPaths = {
    mdiBedOutline,
    mdiBathtubOutline,
    mdiLan,
    mdiCarSide,
    mdiCountertop,
    mdiDumbbell,
    mdiWifi,
    mdiShieldLockOutline
};

export default function PropertyBookModal({ showProperty, handleCloseProperty }) {
    const [PropertyDataList] = useState(PropertyData);
    return (
        <>
            {/* Modal */}
            <Modal show={showProperty} onHide={handleCloseProperty} size="lg" centered>
                <Modal.Header className='p-0' closeButton></Modal.Header>
                <Modal.Body>
                    <Swiper className='property-popup-slider custom-slider pb-5'
                        slidesPerView={1}
                        spaceBetween={20}
                        pagination={{ dynamicBullets: true }}
                        modules={[Autoplay, Pagination]}
                        autoplay={{
                            delay: 3000,
                        }}
                    >
                        {PropertyDataList.Popularslider.map((data, i) =>
                            <SwiperSlide key={i}>
                                <img src={require(`../../images/property-img/${data.propertyImg}`)} alt='' className='img-fluid rounded-3 w-100 pp-slider-img' />
                            </SwiperSlide>
                        )}
                    </Swiper>
                    <div className='d-flex justify-content-between align-items-center  mb-3'>
                        <h6 className='fw-semibold text-secondary fs-15 text-uppercase my-0'>Row House</h6>
                        <div className='d-flex text-warning gap-2 fs-15'>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                        </div>
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                        <div>
                            <p className='mb-1 text-secondary'>Rent Price</p>
                            <h2 className='text-muted mb-0'><span className='text-primary fw-bold'>$1,600</span><span className='fs-15 ps-1'>/Month</span></h2>
                        </div>
                        <button type="button" className="btn btn-primary">Book Now</button>
                    </div>

                    <h3 className='fw-semibold mt-3'>The Most Luxarious House</h3>
                    <div className='text-muted fs-16'>
                        <Icon path={mdiMapMarkerRadiusOutline} className='icon-size-20 me-2' />2972 Poling Farm Road, Fork Drive Hollywood, Bloomfield, NE 68718
                    </div>
                    <hr className='my-4' />

                    <h6 className='fw-semibold fs-18 mb-4'>House Facilities</h6>
                    <Row className='g-3'>
                        {PropertyDataList.PropertyFaciliti.map((data, i) =>
                            <Col sm={6} lg={3} key={i}>
                                <div className='d-flex align-items-center'>
                                    <div className='avatar avatar-sm bg-soft-primary text-primary rounded-circle me-3'>
                                        <Icon path={iconPaths[data.iconName]} className='icon-size-20' />
                                    </div>
                                    <h5 className='fs-16 mb-0'>{data.facilitiName}</h5>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <hr className='my-4' />
                    <h5 className='fw-semibold fs-18 mb-3'>Description</h5>
                    <p className='text-muted'>Welcome to your dream home! This beautiful property is perfect for anyone looking to buy or rent a house that offers comfort, convenience, and style. Nestled in a prime location, this house features modern amenities and a spacious layout designed to meet all your needs.</p>

                    <hr className='my-4' />
                    <h5 className='fw-semibold fs-18 mb-3'>Key Features</h5>
                    <ul className='mb-0 ps-4'>
                        <li className='mb-2'><b className='fw-semibold'>Bedrooms</b>: 3 spacious bedrooms with ample closet space.</li>
                        <li className='mb-2'><b className='fw-semibold'>Bathrooms</b>: 2 full bathrooms with updated fixtures.</li>
                        <li className='mb-2'><b className='fw-semibold'>Kitchen</b>: Fully equipped with modern appliances and plenty of storage.</li>
                        <li className='mb-2'><b className='fw-semibold'>Living Area</b>: Open concept living room with natural light.</li>
                        <li className='mb-2'><b className='fw-semibold'>Outdoor Space</b>: Large backyard perfect for entertaining.</li>
                        <li className='mb-2'><b className='fw-semibold'>Parking</b>: 2-car garage with additional driveway space.</li>
                        <li><b className='fw-semibold'>Neighborhood</b>: Quiet and family-friendly with nearby schools, parks, and shopping centers.</li>
                    </ul>
                </Modal.Body>
            </Modal>
        </>
    )
}
